import React from 'react';
import { Card, Container, Row, Col } from 'shared-portal-component';

import UsersHeader from '@/components/organism/Users/UsersHeader/UsersHeader';
import UsersTable from '@/components/organism/Users/UsersTable/UsersTable';
import PortalUserModal from '@/components/molecules/PortalUsersModal/PortalUsersModal';
import UsersConfirmModalContainer from '@/pages/Users/UsersConfirmModalContainer';
import UsersSuccessModal from '@/components/organism/Users/UsersSuccessModal/UsersSuccessModal';
import type { PortalUserValues } from '@/types/users.types';
import { useUsersPage } from '@/hooks/pages/useUsersPage';

const Users: React.FC = () => {
  const {
    // data
    rows,
    loading,
    deptOptions,
    statusOptions,

    // modal state
    modal,
    isCreate,
    isEdit,
    isUserCreated,
    editingUser,
    closeModal,

    // seat limits
    seatFull,
    seatsReady,

    // filters
    search,
    setSearch,
    scope,
    setScope,
    deptValues,
    setDeptValues,
    statusValues,
    setStatusValues,

    // actions
    openCreate,
    editRow,
    toggleActive,
    canActivateUser,
    forceLogout,
    forceLoginReset,
    removeUser,
    submit,
  } = useUsersPage();

  return (
    <Container fluid>
      <Row spacing="none">
        <Col>
          <Card>
            <UsersHeader
              searchPlaceholder="Search Users..."
              searchValue={search}
              onSearchChange={setSearch}
              onSearch={() => {}}
              scope={scope}
              onScopeChange={setScope}
              deptOptions={deptOptions}
              statusOptions={statusOptions}
              deptValues={deptValues}
              statusValues={statusValues}
              onDeptChange={(vals) => {
                setDeptValues(vals.filter((v) => v !== 'Dept / Org'));
              }}
              onStatusChange={(vals) => {
                setStatusValues(vals.filter((v) => v !== 'Status'));
              }}
              onCreate={openCreate}
            />

            <UsersTable
              rows={rows}
              loading={loading}
              onEdit={editRow}
              onToggleActive={toggleActive}
              canActivate={canActivateUser}
              onForceLogout={forceLogout}
              onForceLoginReset={forceLoginReset}
              onDelete={removeUser}
            />
          </Card>
        </Col>
      </Row>

      {(isCreate || isEdit) && (
        <PortalUserModal
          open
          onClose={closeModal}
          onSubmit={(values: PortalUserValues) => {
            void submit(values);
          }}
          title={isCreate ? 'Create Portal User' : 'Edit Portal User'}
          submitText={isCreate ? 'Create' : 'Save Changes'}
          modalSize="sm"
          deptOrgOptions={deptOptions.filter((d) => d !== 'Dept / Org')}
          enforceSeatLimit={isCreate}
          seatFull={seatFull}
          seatsReady={seatsReady}
          initialValues={
            isEdit && editingUser !== undefined
              ? {
                  userType: editingUser.userType as PortalUserValues['userType'],
                  name: editingUser.name,
                  email: editingUser.email,
                  phone: editingUser.phone,
                  deptOrg: editingUser.deptOrg,
                  sendInvite: false,
                  forcePasswordReset: false,
                }
              : undefined
          }
        />
      )}

      <UsersConfirmModalContainer />

      {isUserCreated && modal !== null && 'invitationLink' in modal && 'otp' in modal && (
        <UsersSuccessModal
          open
          invitationLink={modal.invitationLink}
          otp={modal.otp}
          onClose={closeModal}
        />
      )}
    </Container>
  );
};

export default Users;
